import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { generateCodes,getpanelproducts } from "../../api/ProductAssignment/productAssignment";
import ResponseStatus from "../../util/enums";
import ProcessTypeToggle from "./components/ProcessTypeToggle/ProcessTypeToggle";
import ProductList from "./components/ProductList/ProductList";
import ReasonInput from "./components/ReasonInput/ReasonInput";
import GeneratedCodes from "./components/GeneratedCodesList/GeneratedCodesList";
// import './ProductAssignment.css'

const ProductCodePage = ({ onBack }) => {
  const [loader, setLoader] = useState(false);
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [reason, setReason] = useState("");
  const [processType, setProcessType] = useState(null);
  const [count, setCount] = useState(1);
  const [codes, setCodes] = useState([]);
  const [promotionName, setPromotionName] = useState("");

  const adminUser = JSON.parse(localStorage.getItem("user"));
  const userAdminToken = sessionStorage.getItem("jwtP");

  // 🔹 Fetch available products
  const getPanelProductsHandler = async () => {
    setLoader(true);
    try {
      const res = await getpanelproducts(userAdminToken);
      setLoader(false);

      if (res.data && res.data.ResponseStatus === ResponseStatus.Success) {
        setProducts(res.data.ResponseData);
      } else {
        toast.error(res.data.ResponseMessage || "Ürünler alınamadı");
      }
    } catch (error) {
      setLoader(false);
      toast.error("Sunucu bağlantı hatası");
    }
  };

  // 🔹 Generate codes for selected product
  const generateCodesHandler = async () => {
    if (!selectedProduct || !reason || !processType || !count) {
      toast.error("Lütfen tüm alanları doldurun.");
      return;
    }

    setLoader(true);
    try {
      const payload = {
        Description: `${processType || ""} - ${reason || ""}`,
        Count: count,
        PromotionName: promotionName,
        StoreProductId: selectedProduct.ProductId,
      };

      const res = await generateCodes(payload, userAdminToken, true);
      setLoader(false);

      if (res.data && res.data.ResponseStatus === ResponseStatus.Success) {
        if (res.data.ResponseData) {
          setCodes(res.data.ResponseData);
        }
        toast.success("Kodlar başarıyla oluşturuldu!");
      } else if (
        res.data &&
        res.data.ResponseStatus === ResponseStatus.DataIsNull
      ) {
        toast.error("Kod oluşturulamadı, data is null.");
      } 
      // else {
      //   toast.error(res.data.ResponseMessage || "Kod oluşturulamadı.");
      // }
    } catch (error) {
      setLoader(false);
      console.log("error",error);
      toast.error(error);
    }
  };

  useEffect(() => {
    getPanelProductsHandler();
  }, []);


  const isProcessStepEnabled = true;
  const isProductStepEnabled = !!processType;
  const isDetailsStepEnabled = !!selectedProduct;

  return (
    <div className="product-code-page">
      <ToastContainer />
      <div className="header">
        <h2>Kod Oluşturma</h2>
        <button onClick={onBack}>Geri Dön</button>
      </div>
      <div className="code-page-layout">
        <div
          style={
            {
              // display: "flex",
              // flexDirection: "column",
              // width: "70%",
            }
          }
        >
          <div
            className={`section-wrapper ${
              isProcessStepEnabled ? "enabled" : "disabled"
            }`}
          >
            <ProcessTypeToggle value={processType} onChange={setProcessType} />
          </div>
          <div
            className={`section-wrapper ${
              isProductStepEnabled ? "enabled" : "disabled"
            }`}
          >
            <ProductList
              list={products}
              selected={selectedProduct}
              onSelect={setSelectedProduct}
            />
            {!isProductStepEnabled && <div className="overlay" />}
          </div>
        </div>

        <div className="reasonAndButtonsBox">
          <div
            className={`section-wrapper ${
              isDetailsStepEnabled ? "enabled" : "disabled"
            }`}
          >
            <ReasonInput value={reason} onChange={setReason} />
            <div className="promotion-name-input">
              <label>Promotion Name</label>
              <input
                type="text"
                placeholder="Örn: MEN2025"
                value={promotionName}
                onChange={(e) => setPromotionName(e.target.value.toUpperCase())}
                style={{ textTransform: "uppercase" }}
              />
            </div>

            <div className="count-input">
              <label>Kaç adet kod oluşturulsun?</label>
              <input
                type="number"
                min="1"
                max="10"
                value={count === 0 ? "" : count}
                onChange={(e) => {
                  const input = e.target.value;

                  // Allow clearing (empty string)
                  if (input === "") {
                    setCount("");
                    return;
                  }

                  // Convert to number
                  const num = Number(input);

                  // Prevent non-numeric or out-of-range values
                  if (!isNaN(num) && num >= 1 && num <= 10) {
                    setCount(num);
                  }

                  // If value goes below min or above max, clamp it
                  if (num < 1) setCount(1);
                  if (num > 10) setCount(10);
                }}
              />
            </div>

            <button
              className="primary-btn-code-generation"
              onClick={generateCodesHandler}
              disabled={
                loader ||
                reason.trim().length < 10 ||
                promotionName.trim().length === 0
              }
            >
              {loader ? "Oluşturuluyor..." : "Kod Oluştur"}
            </button>
            <GeneratedCodes codes={codes} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCodePage;
